module.exports = __webpack_public_path__ + "static/wit-logo-136278cd98958cfe15a2db533a52adf8.svg";